import React, { ErrorInfo, ReactNode } from 'react';
import { DEBUG } from '../utils/debug';

interface ErrorBoundaryProps {
  children: ReactNode;
  fallback?: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
  error: Error | null;
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    // You can log error details here (to an error reporting service)
    if (DEBUG) {
      // logging removed
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        this.props.fallback || (
          <div style={{ padding: 32, textAlign: 'center', color: '#b71c1c' }}>
            <h2>Something went wrong.</h2>
            <pre>{this.state.error?.message}</pre>
            <button onClick={() => window.location.reload()}>Reload Page</button>
          </div>
        )
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
